export default __webpack_public_path__ + "assets/images/62c05b8aa95fa8e612ee5da868729c78-safe_for_you_and_environment.svg";